<template>
  <div v-if="item">
    <div
      class="px-4 markdown my-2 w-full sm:px-0 max-w-md mx-auto"
      v-if="itemType === 'text'"
    >
      <vue-markdown
        :source="item.value"
        :anchorAttributes="{
          target: '_blank',
          rel: 'nofollow',
        }"
        linkify
      />
    </div>
    <div v-if="itemType === 'youtube'">
      <youtube :url="item.value" />
    </div>
    <div v-if="itemType === 'survey' && item.survey_id">
      <div class="mx-6 my-4 sm:max-w-lg sm:mx-auto" v-if="authenticated">
        <survey :survey-id="item.survey_id" />
      </div>
      <div class="p-2" v-else>
        <div
          class="my-4 w-full p-8 sm:max-w-lg sm:mx-auto border border-primary-500 grid justify-center gap-1 rounded"
        >
          <div class="mx-auto text-5xl mb-2">
            <icon
              name="WaldigLogo"
              :settings="{ circle: true, strokeWidth: 1 }"
            />
          </div>
          <div class="mb-2 text-center">
            {{ $t("surveys.survey_not_visible_unauthenticated") }}
          </div>
          <div class="text-center">
            <wd-button @input="goTo('/login')">{{
              $t("login.login_now")
            }}</wd-button>
          </div>
          <div class="text-center">{{ $t("general.or") }}</div>
          <div class="text-center">
            <wd-button @input="goTo('/register')">{{
              $t("login.register_free")
            }}</wd-button>
          </div>
        </div>
      </div>
    </div>
    <div class="my-4" v-if="itemType === 'image' && item.image">
      <single-image :image="item.image" />
    </div>
  </div>
</template>

<script>
import { NewsEntryItem } from "@/modules/home/viewmodels/NewsEntryItem";

import VueMarkdown from "vue-markdown";

const Youtube = require("@/modules/home/components/Youtube.vue").default;
const Survey = require("@/modules/surveys/components/Survey.vue").default;
const SingleImage = require("@/modules/images/components/SingleImage.vue")
  .default;

export default {
  name: "NewsEntryItem",
  data() {
    return {};
  },
  props: {
    item: {
      type: NewsEntryItem,
      required: true,
    },
    authenticated: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VueMarkdown,
    Youtube,
    Survey,
    SingleImage,
  },
  methods: {},
  computed: {
    itemType() {
      return this.item.type;
    },
  },
  created() {},
};
</script>
